import { UiService } from '@services/ui.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { Article, PatchArticle } from '@classes/article';
import { Tariff } from '@classes/tariff';
import { AuthService } from './auth.service';
import { RoleName } from '@enums/role-name.enum';

@Injectable({
  providedIn: 'root',
})
export class ArticlesService {
  articlesListChanged = new Subject<Article[]>();
  articlesFormated: any[] = [];
  articlesFormatedListChanged = new Subject<any[]>();
  private baseUrl: string = environment.apiUrl + 'articles';
  private subcontractorAdminBaseUrl: string =
    environment.apiUrl + 'subcontractors/articles';
  private articles: Article[] = [];

  constructor(
    private http: HttpClient,
    private uiSrv: UiService,
    private authService: AuthService,
  ) {}

  private _getBaseUrl(isClientSubcontractor: boolean): string {
    if (this._isSubcontractorMode(isClientSubcontractor)) {
      return this.subcontractorAdminBaseUrl;
    }

    return this.baseUrl;
  }

  private _isSubcontractorMode(isClientSubcontractor: boolean): boolean {
    const authUser = this.authService.getUser();
    const isAuthUserAdmin =
      authUser.role.name === RoleName.admin ||
      authUser.role.name === RoleName.admin_subcontractor ||
      authUser.role.name === RoleName.bizzdev;

    return isClientSubcontractor && isAuthUserAdmin;
  }

  get(idSite: string): Observable<Article[]> {
    return this.http.get<Article[]>(`${this.baseUrl}?siteId=${idSite}`).pipe(
      map((articles) => {
        // this.articles = articles.map(c => Article.fromObject(c));
        this.articles = articles;
        this.articlesListChanged.next([...this.articles]);
        return [...this.articles];
      }),
    );
  }

  getFormated(
    filters: any,
    showIncompleteTariffs: boolean,
    isClientSubcontractor: boolean = false,
  ): Observable<any[]> {
    let httpParams = new HttpParams();
    const filtersQuery = [];

    if (filters.site) {
      filtersQuery.push(`siteId==${filters.site}`);
    }

    if (showIncompleteTariffs) {
      filtersQuery.push(
        this._isSubcontractorMode(isClientSubcontractor)
          ? `IncompleteTariffSubcontractors`
          : `IncompleteTariffs`,
      );
    }

    if (filters.urgency) {
      filtersQuery.push(`urgency@=${filters.urgency}`);
    }

    if (filters.sender) {
      filtersQuery.push(`sender@=${filters.sender}`);
    }

    if (filters.step) {
      filtersQuery.push(`step@=${filters.step}`);
    }

    httpParams = httpParams.append('Filters', filtersQuery.join());

    return this.http
      .get<
        Article[]
      >(`${this._getBaseUrl(isClientSubcontractor)}`, { params: httpParams })
      .pipe(
        map((articles) => {
          // this.articles = articles.map(c => Article.fromObject(c));
          this.articles = articles;
          this.articlesFormated = [];
          this.articles.map((article) => {
            let stepsFormated = [];

            article.steps.map((step) => {
              let daysWeek = {
                dayPrice: null,
                days: [],
                id: null,
                nightPrice: null,
              };

              let saturday = {
                dayPrice: null,
                days: [],
                id: null,
                nightPrice: null,
              };

              let sunday = {
                dayPrice: null,
                days: [],
                id: null,
                nightPrice: null,
              };

              let noDays = {
                dayPrice: null,
                id: null,
                nightPrice: null,
              };

              step.tariffs.map((tariff) => {
                if (!tariff.days) {
                  noDays.id = tariff.id;
                  noDays.dayPrice = tariff.dayPrice;
                  noDays.nightPrice = tariff.nightPrice;
                } else if (tariff.days.length === 0) {
                  noDays.id = tariff.id;
                  noDays.dayPrice = tariff.dayPrice;
                  noDays.nightPrice = tariff.nightPrice;
                } else if (tariff.days[0] === 0) {
                  sunday.id = tariff.id;
                  sunday.days = [0];
                  sunday.dayPrice = tariff.dayPrice;
                  sunday.nightPrice = tariff.nightPrice;
                } else if (tariff.days[0] === 6) {
                  saturday.id = tariff.id;
                  saturday.days = [6];
                  saturday.dayPrice = tariff.dayPrice;
                  saturday.nightPrice = tariff.nightPrice;
                } else {
                  daysWeek.id = tariff.id;
                  daysWeek.days = tariff.days;
                  daysWeek.dayPrice = tariff.dayPrice;
                  daysWeek.nightPrice = tariff.nightPrice;
                }
              });
              let stepFormated = {
                id: step.id,
                address: step.address,
                otherAddress: step.otherAddress,
                hasPhoto: step.hasPhoto,
                hasSignature: step.hasSignature,
                isDelivery: step.isDelivery,
                isPickup: step.isPickup,
                distance: article.distance,
                isPricedPerKm: article.isKilometricPricing,
                daysWeek: daysWeek,
                saturday: saturday,
                sunday: sunday,
                noDays: noDays,
              };

              stepsFormated.push(stepFormated);
            });

            let articleFormated = {
              id: article.id,
              name: article.name,
              sender: article.sender,
              site: article.site,
              urgency: article.urgency,
              stepsFormated: stepsFormated,
              // tariffs: article.tariffs,
              // daysWeek: daysWeek,
              // saturday: saturday,
              // sunday: sunday,
              // noDays: noDays
            };

            this.articlesFormated.push(articleFormated);
          });
          // this.articlesFormatedListChanged.next([...this.articlesFormated]);
          return [...this.articlesFormated];
        }),
      );
  }

  updateList() {
    this.articlesFormated = [];
    this.articles.map((article) => {
      let stepsFormated = [];

      article.steps.map((step) => {
        let daysWeek = {
          dayPrice: null,
          days: [],
          id: null,
          nightPrice: null,
        };

        let saturday = {
          dayPrice: null,
          days: [],
          id: null,
          nightPrice: null,
        };

        let sunday = {
          dayPrice: null,
          days: [],
          id: null,
          nightPrice: null,
        };

        let noDays = {
          dayPrice: null,
          id: null,
          nightPrice: null,
        };

        step.tariffs.map((tariff) => {
          if (!tariff.days) {
            noDays.id = tariff.id;
            noDays.dayPrice = tariff.dayPrice;
            noDays.nightPrice = tariff.nightPrice;
          } else if (tariff.days.length === 0) {
            noDays.id = tariff.id;
            noDays.dayPrice = tariff.dayPrice;
            noDays.nightPrice = tariff.nightPrice;
          } else if (tariff.days[0] === 0) {
            sunday.id = tariff.id;
            sunday.days = [0];
            sunday.dayPrice = tariff.dayPrice;
            sunday.nightPrice = tariff.nightPrice;
          } else if (tariff.days[0] === 6) {
            saturday.id = tariff.id;
            saturday.days = [6];
            saturday.dayPrice = tariff.dayPrice;
            saturday.nightPrice = tariff.nightPrice;
          } else {
            daysWeek.id = tariff.id;
            daysWeek.days = tariff.days;
            daysWeek.dayPrice = tariff.dayPrice;
            daysWeek.nightPrice = tariff.nightPrice;
          }
        });

        let stepFormated = {
          id: step.id,
          address: step.address,
          otherAddress: step.otherAddress,
          hasPhoto: step.hasPhoto,
          hasSignature: step.hasSignature,
          isDelivery: step.isDelivery,
          isPickup: step.isPickup,
          distance: article.distance,
          isPricedPerKm: article.isKilometricPricing,
          daysWeek: daysWeek,
          saturday: saturday,
          sunday: sunday,
          noDays: noDays,
        };

        stepsFormated.push(stepFormated);
      });

      let articleFormated = {
        id: article.id,
        name: article.name,
        sender: article.sender,
        site: article.site,
        urgency: article.urgency,
        stepsFormated: stepsFormated,
        // tariffs: article.tariffs,
        // daysWeek: daysWeek,
        // saturday: saturday,
        // sunday: sunday,
        // noDays: noDays
      };

      this.articlesFormated.push(articleFormated);
    });
    this.articlesFormatedListChanged.next([...this.articlesFormated]);
  }

  put(article: Article): Observable<Article> {
    return this.http.put<Article>(this.baseUrl, article).pipe(
      tap((editedArticle) => {
        // editedArticle = Article.fromObject(editedArticle);
        this.articles = this.articles.map((c) =>
          c.id === editedArticle.id ? editedArticle : c,
        );
        this.articlesListChanged.next([...this.articles]);
        this.uiSrv.showSnackbar('Article édité avec succès', false);
      }),
    );
  }

  post(article: any): Observable<any> {
    return this.http.post<any>(this.baseUrl, article).pipe(
      tap((createdarticle) => {
        // createdarticle = Article.fromObject(createdarticle);
        this.articles.push(createdarticle);
        this.articlesListChanged.next([...this.articles]);

        this.uiSrv.showSnackbar('Article créé avec succès', false);
        this.updateList();
      }),
    );
  }

  putStepArticle(
    articleId: string,
    stepId: string,
    tariffs: Tariff[],
    isClientSubcontractor: boolean,
  ): Observable<any> {
    return this.http
      .put<
        Tariff[]
      >(`${this._getBaseUrl(isClientSubcontractor)}/${articleId}/steps/${stepId}/tariffs`, tariffs)
      .pipe(
        tap((editedArticle) => {
          // editedArticle = Article.fromObject(editedArticle);
          this.articles = this.articles.map((c) =>
            c.id === editedArticle.id ? editedArticle : c,
          );
          this.articlesListChanged.next([...this.articles]);
          this.updateList();
        }),
      );
  }

  generateArticles(siteId: string): Observable<any> {
    return this.http
      .post<any>(`${this.baseUrl}/generate?siteId=${siteId}`, null)
      .pipe(
        tap((createdarticle) => {
          // createdarticle = Article.fromObject(createdarticle);
          // this.articles.push(createdarticle);
          // this.articlesListChanged.next([...this.articles]);
        }),
      );
  }

  generateArticleByOrderId(orderId: string): Observable<any> {
    return this.http
      .post<any>(`${this.baseUrl}/generate?orderId=${orderId}`, null)
      .pipe(
        tap((createdarticle) => {
          // createdarticle = Article.fromObject(createdarticle);
          // this.articles.push(createdarticle);
          // this.articlesListChanged.next([...this.articles]);
          this.uiSrv.showSnackbar('Article généré avec succès', false);
        }),
      );
  }

  // DELETE

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`).pipe(
      tap(() => {
        this.articles = this.articles.filter((c) => c.id !== id);
        this.articlesListChanged.next([...this.articles]);
        this.updateList();
      }),
    );
  }

  patch(id: string, article: PatchArticle): Observable<Article> {
    return this.http.patch<Article>(`${this.baseUrl}/${id}`, article).pipe(
      tap((editedArticle) => {
        // editedArticle = Article.fromObject(editedArticle);
        this.articles = this.articles.map((c) =>
          c.id === editedArticle.id ? editedArticle : c,
        );
        this.articlesListChanged.next([...this.articles]);
        this.updateList();
      }),
    );
  }
}
